module.exports = "//cdn.mxpnl.com/static/asset-cache/8136c61701e15584254acad4ee122691/iron/common/assets/images/charts/bar.svg";